// src/pages/admin/AdminListings.js
import React, { useState, useEffect } from 'react';
import api from '../../utils/api';
import toast from 'react-hot-toast';

export default function AdminListings() {
  const [listings, setListings] = useState([]);
  const load = () => api.get('/admin/listings').then(r => setListings(r.data.listings || [])).catch(() => {});
  useEffect(() => { load(); }, []);

  const setStatus = async (id, status) => {
    await api.put(`/admin/listings/${id}/status`, { status });
    toast.success(`Listing ${status}`);
    load();
  };

  const setTrust = async (id, trust_level) => {
    await api.put(`/admin/listings/${id}/trust`, { trust_level });
    toast.success(`Trust level set to ${trust_level}`);
    load();
  };

  const statusColor = { active: 'green', cancelled: 'pink', sold: 'cyan', suspended: 'orange' };
  const typeColor = { individual: '#00ff88', organization: '#00e5ff', compliance_entity: '#ff6600' };
  const trustColor = { self_reported: 'var(--neon-yellow)', docs_checked: 'var(--neon-cyan)', verified: 'var(--neon-green)' };
  const trustLabel = { self_reported: 'Self-reported', docs_checked: 'Docs checked', verified: 'Verified' };

  return (
    <div>
      <div className="section-tag">Admin</div>
      <h1 className="section-title">LISTING <span style={{ color: 'var(--neon-cyan)' }}>MANAGEMENT</span></h1>
      <p style={{ color: 'var(--muted)', fontFamily: 'Space Mono, monospace', fontSize: '0.75rem', margin: '0.5rem 0 2rem' }}>{listings.length} total listings</p>

      <div className="card">
        <div style={{ overflow: 'auto' }} className="thin-scroll">
          <table className="data-table" style={{ minWidth: '900px' }}>
            <thead><tr><th>Title</th><th>Seller</th><th>Type</th><th>Qty</th><th>Price</th><th>Verified By</th><th>Trust</th><th>Status</th><th>Created</th><th>Actions</th></tr></thead>
            <tbody>
              {listings.map(l => (
                <tr key={l.id}>
                  <td>
                    <div style={{ fontWeight: 600, fontSize: '0.85rem' }}>{l.title}</div>
                    <div style={{ color: 'var(--muted)', fontSize: '0.65rem' }}>{l.project}</div>
                  </td>
                  <td style={{ fontSize: '0.75rem' }}>{l.seller_name}</td>
                  <td><span className="badge" style={{ color: typeColor[l.seller_type], borderColor: typeColor[l.seller_type], fontSize: '0.55rem' }}>{l.seller_type}</span></td>
                  <td style={{ fontFamily: 'Space Mono, monospace', fontSize: '0.72rem' }}>{l.qty_available}/{l.qty_original}</td>
                  <td style={{ color: 'var(--neon-green)', fontFamily: 'Space Mono, monospace' }}>₹{l.price_per_unit.toLocaleString()}</td>
                  <td style={{ color: 'var(--muted)', fontSize: '0.65rem' }}>{l.verified_by}</td>
                  <td>
                    <select
                      className="form-select"
                      style={{ fontSize: '0.65rem', padding: '0.2rem 0.4rem', minWidth: '120px', color: trustColor[l.trust_level] || 'var(--muted)' }}
                      value={l.trust_level || 'self_reported'}
                      onChange={(e) => setTrust(l.id, e.target.value)}
                    >
                      <option value="self_reported">Self-reported</option>
                      <option value="docs_checked">Docs checked</option>
                      <option value="verified">Verified</option>
                    </select>
                  </td>
                  <td><span className={`badge badge-${statusColor[l.status] || 'muted'}`}>{l.status}</span></td>
                  <td style={{ color: 'var(--muted)', fontSize: '0.65rem' }}>{new Date(l.created_at).toLocaleDateString('en-IN')}</td>
                  <td>
                    <div style={{ display: 'flex', gap: '0.3rem' }}>
                      {l.status === 'active' && <button className="btn btn-sm btn-danger" onClick={() => setStatus(l.id, 'cancelled')}>Remove</button>}
                      {l.status === 'cancelled' && <button className="btn btn-sm btn-primary" onClick={() => setStatus(l.id, 'active')}>Restore</button>}
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
